import {PostRequest} from "../../../components/request";
import {store} from "../../storeConfig/store";
import totalCalculationCart from "../../../components/utils/totalCalculationCart";

export const getPing = () => dispatch => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    PostRequest('/api/authorize/ping',
        {
            token: token
        }).then((result) => {
        let response = result.data;
        if (response.ok) {
            localStorage.setItem("token", response.data.token);
            dispatch({
                type: "LOGIN",
                payload: response.data.token
            });
            if (response.data.cart) {
                dispatch({
                    type: "CART",
                    payload: {
                        count: response.data.cart.count,
                        price: response.data.cart.price
                    }
                });
            } else {
                dispatch({
                    type: "CART",
                    payload: {}
                });
            }
        } else {
            let cartItems = localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : "";
            if (cartItems)
                totalCalculationCart(cartItems)
            else
                logout();
        }
    }).catch((err) => {
        logout();
    });
}

const logout = () => {
    store.dispatch({type: "LOGOUT", payload: {}});
    localStorage.removeItem("token");
    //window.location.reload();
}
